import { Heading } from '@zillow/constellation-10';

import {
  PAGE_BILLING_ADDRESS_ACH,
  PAGE_BILLING_ADDRESS_CARD,
  PAGE_CARD_INPUT,
  PAGE_DUPLICATE_WARNING,
  PAGE_PAYMENT_TYPE_SELECTION,
} from '../../pageFlows';

export const Header = ({ currentPage, headerSize = 'sm' }) => {
  const headerMessages = {
    [PAGE_PAYMENT_TYPE_SELECTION]: 'Which payment method would you like to use?',
    [PAGE_CARD_INPUT]: 'Enter your card details',
    [PAGE_BILLING_ADDRESS_ACH]: 'What is your current mailing address and phone number?',
    [PAGE_BILLING_ADDRESS_CARD]: 'What is your billing address?',
    [PAGE_DUPLICATE_WARNING]: 'Duplicate payment method detected',
  };
  return (
    <Heading
      level={1}
      textStyle={headerSize === 'lg' ? 'heading-sm' : 'heading-xs'}
      css={headerSize === 'lg' ? { marginBottom: 'default' } : undefined}
    >
      {headerMessages[currentPage]}
    </Heading>
  );
};

export default Header;
